import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ActionsGroup, Dialog, DialogActions, DialogContent, DialogTitle, FlatButton, RaisedButton } from "@evergis/ui";

import { RelatedLayerDescription } from "./styled";
import { createLayerItem } from "../../../evergis/core/project/createProjectContent";
import { useDialogInfo, useDialogReset } from "../../../hooks/useDialogs";
import { useProjectInfo, useProjectUpdate } from "../../../ducks/project/hooks";
import { useDefaultScaleRange } from "../../../hooks/style/useDefaultScaleRange";

export const AddRelatedLayer: FC = () => {
  const { t } = useTranslation("dialogs");
  const [{ content }] = useProjectInfo();
  const { items } = content;
  const mutation = useProjectUpdate();
  const resetDialog = useDialogReset();
  const defaultScaleRange = useDefaultScaleRange();

  const {
    resources: [resourceName, resourceAlias],
    options: { addToMap },
  } = useDialogInfo<string[], { addToMap: VoidFunction }>();

  const onSubmit = useCallback(async () => {
    const newLayerItem = createLayerItem(
      defaultScaleRange[0],
      defaultScaleRange[1],
    )({ name: resourceName, alias: resourceAlias });

    await mutation({
      content: {
        items: [newLayerItem, ...items],
      },
    });

    resetDialog();
    addToMap();
  }, [addToMap, defaultScaleRange, items, mutation, resetDialog, resourceAlias, resourceName]);

  return (
    <Dialog isOpen maxWidth={"39rem"} onCloseRequest={resetDialog} hasClickAway={false}>
      <DialogTitle>{t("addRelatedLayer.title")}</DialogTitle>
      <DialogContent>
        <RelatedLayerDescription>
          {t("addRelatedLayer.description").replace("{alias}", resourceAlias || resourceName)}
        </RelatedLayerDescription>
      </DialogContent>
      <DialogActions>
        <ActionsGroup>
          <RaisedButton onClick={onSubmit} primary>
            {t("dialogComponents.addLayer")}
          </RaisedButton>
          <FlatButton onClick={resetDialog}>{t("actions.cancel", { ns: "common" })}</FlatButton>
        </ActionsGroup>
      </DialogActions>
    </Dialog>
  );
};
